/**
 * IMPORTS
 */
import {gql} from '@apollo/client';


/**
 * I am a mutation to create NPS feedback
 */
export const CREATE_NPS_FEEDBACK = gql`
    mutation createNPSFeedback(
        $company: Int!
        $date: String!
        $name: String!
        $response: String
        $role: String!
        $score: Int
        $server: String!
        $user: String!
    ) {
        createNPSFeedback(
            company: $company,
            date: $date,
            name: $name,
            response: $response,
            role: $role,
            score: $score,
            server: $server,
            user: $user
        ) {
            id
        }
    }
`;


/**
 * I am a mutation to create queue.
 */
export const CREATE_QUEUE = gql`
    mutation createQueue (
        $name: String!,
        $scheduler: QueueSchedulerInput!
    ) {
        result: createQueue (name: $name, scheduler: $scheduler) {
            __typename

            ...on Queue {
                agents {
                    uid
                }
                id
                name
                scheduler {
                    type
                }
            }

            ...on Error {
                code
                info
            }
        }
    }
`;


/**
 * I am a mutation to delete queue.
 */
export const DELETE_QUEUE = gql`
    mutation deleteQueue ($queue: Int!) {
        result: deleteQueue (queue: $queue) {
            __typename

            ...on Queue {
                agents {
                    uid
                }
                id
                name
                scheduler {
                    type
                }
            }

            ...on Error {
                code
                info
            }
        }
    }
`;


/**
 * I am a mutation to update company dynamics.
 */
export const UPDATE_COMPANY_DYNAMICS = gql`
    mutation patchDynamics($input: [DynamicVariablePatchInput!]!) {
        result: patchDynamics(input: $input) {
            __typename

            ...on PatchDynamics {
                success
            }

            ...on Error {
                code
                info
            }
        }
    }
`;


/**
 * I am a mutation to update kanbans.
 */
export const UPDATE_KANBANS = gql`
    mutation updateKanbans($columns: [KanbanInput!]!) {
        result: updateKanbans(columns: $columns) {
            id
            name
            prio
            tag
        }
    }
`;


/**
 * I am a mutation to update user password.
 */
export const UPDATE_PASSWORD = gql`
    mutation updatePassword($_new: String!, $old: String!) {
        updatePassword(_new: $_new, old: $old) {
            __typename
            ...on UpdatePassword {
                success
            }
            ...on Error {
                code
                info
            }
        }
    }
`;


/**
 * I am a mutation to update a queue.
 */
export const UPDATE_QUEUE = gql`
    mutation updateQueue (
        $name: String,
        $queue: Int!,
        $scheduler: QueueSchedulerInput
    ) {
        result: updateQueue (
            name: $name,
            queue: $queue,
            scheduler: $scheduler
        ) {
            __typename

            ...on Queue {
                agents {
                    uid
                }
                id
                name
                scheduler {
                    type
                }
            }

            ...on Error {
                code
                info
            }
        }
    }
`;


/**
 * I am a mutation to update queue agents.
 */
export const UPDATE_QUEUE_AGENTS = gql`
    mutation updateQueueAgents (
        $queue: Int!,
        $agents: [String!]!
    ) {
        result: updateQueueAgents (
            queue: $queue,
            agents: $agents
        ) {
            __typename

            ...on Queue {
                agents {
                    uid
                }
                id
                name
                scheduler {
                    type
                }
            }

            ...on Error {
                code
                info
            }
        }
    }
`;


/**
 * I am a mutation to update user config
 */
export const UPDATE_USER_CONFIG = gql`
    mutation updateUserConfig($input: UserConfigInput!) {
        updateUserConfig(input: $input) {
            __typename
            ...on UpdateUserConfig {
                ai {
                    apiKey
                }
                answerAlert
                menu
                messages {
                    body
                    key
                }
                prompts {
                    qualityReport
                }
            }
            ...on Error {
                code
                info
            }
        }
    }
`;

